import script from "./booking-of-infrastructure.vue?vue&type=script&lang=ts&setup=true"
export * from "./booking-of-infrastructure.vue?vue&type=script&lang=ts&setup=true"

import "./booking-infrastructure-drawer.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__